/* eslint-disable no-unreachable */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker';

import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import SecuredImage from 'modules/common/components/SecuredImage';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateMarriageModal({
  createUpperCaseInput,
  createMarriageCertificate,
  formData,
  getMarriageCertificateList,
  history,
  showMarriageCertificate,
  getRoleList,
  setFormData,
  creating,
  createSelect,
  // syncToEs,
}) {
  const setModal = useContext(ModalContext);

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const onUpload = (side) => (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      setFormData({
        ...formData,
        [`${side}`]: reader.result,
        [`${side}_file`]: file,
      });
    };

    reader.readAsDataURL(file);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    // const data = new FormData();
    const formD = new FormData();
    formD.append('test', 'dasd');

    for (const key in formData) {
      if (
        key !== 'front_page_file' &&
        key !== 'back_page_file' &&
        key !== 'front_page' &&
        key !== 'back_page'
      ) {
        formD.append(key, formData[key]);
      }
    }

    formD.append('front_page', _.get(formData, 'front_page_file'));
    formD.append('back_page', _.get(formData, 'back_page_file'));
    formD.set(
      'husband_first_name',
      _.get(formData, 'husband_first_name').toUpperCase()
    );
    formD.set(
      'husband_last_name',
      _.get(formData, 'husband_last_name').toUpperCase()
    );

    if (_.get(formData, 'husband_middle_name') === undefined) {
      formD.set('husband_middle_name', '');
    } else {
      formD.set(
        'husband_middle_name',
        _.get(formData, 'husband_middle_name').toUpperCase()
      );
    }

    formD.set(
      'wife_first_name',
      _.get(formData, 'wife_first_name').toUpperCase()
    );
    formD.set(
      'wife_last_name',
      _.get(formData, 'wife_last_name').toUpperCase()
    );

    if (_.get(formData, 'wife_middle_name') === undefined) {
      formD.set('wife_middle_name', '');
    } else {
      formD.set(
        'wife_middle_name',
        _.get(formData, 'wife_middle_name').toUpperCase()
      );
    }

    createMarriageCertificate(formD, (data) => {
      setModal({ isOpen: false });
      getMarriageCertificateList();
      history.push(
        `/civil-registry/marriage-certificate/records-maintenance/${_.get(
          data,
          'data.id'
        )}`
      );
      // syncToEs({ id: _.get(data, 'data.id') });
      showMarriageCertificate(_.get(data, 'data.id'));
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="">Document&apos;s Owner Personal Information</div>
        <div className="border border-primary row m-1 p-1">
          <div className="col-12">Name of Man/Husband</div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'registry_number', label: 'Registry Number:' },
              { required: true, placeholder: 'registry_number' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'husband_first_name', label: 'First Name' },
              { required: true, placeholder: 'First Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'husband_middle_name', label: 'Middle Name:' },
              { required: false, placeholder: 'Middle Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'husband_last_name', label: 'Last Name:' },
              { required: true, placeholder: 'Last Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'husband_extension_name',
                label: 'Extension Name',
              },
              c.EXTENSION_NAMES
            )}
          </div>
          <div className="col-12">Name of Lady/Wife</div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'wife_first_name', label: 'First Name' },
              { required: true, placeholder: 'First Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'wife_middle_name', label: 'Middle Name:' },
              { required: false, placeholder: 'Middle Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'wife_last_name', label: 'Last Name:' },
              { required: true, placeholder: 'Last Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'wife_extension_name',
                label: 'Extension Name',
              },
              c.EXTENSION_NAMES
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'volume', label: 'Volume' },
              { required: true, placeholder: 'Volume' }
            )}
          </div>
          {/* <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'fatal', label: 'Fatal' },
              { required: true, placeholder: 'fatal' }
            )}
          </div> */}
          {/* 
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'birth_place', label: 'Place of birth' },
              { required: true, placeholder: 'Place of Birth' }
            )}
          </div> */}

          <div className="col-3 form-group">
            <label className="form-label">
              Date of Marriage:
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date_marriage')}
              value={_.get(formData, 'date_marriage') || ''}
              maxDate={new Date()}
            />
          </div>
        </div>

        <div className="">Marriage Certificates</div>
        <div className="border border-primary row m-1 p-1">
          <div className="col-md-6">
            <label>Front</label>
            <div className="col-12 bc-image ">
              <SecuredImage
                className="img-proportion"
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="MC"
                src={_.get(formData, 'front_page') || ImagePlaceholder}
              />
            </div>
            <div className="col-12 ">
              <input
                style={{ width: '100%' }}
                type="file"
                className="file-elip btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload('front_page')}
              />
            </div>
          </div>
          <div className="col-md-6">
            <label>Back</label>
            <div className="col-12 bc-image ">
              <SecuredImage
                className="img-proportion"
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="MC"
                src={_.get(formData, 'back_page') || ImagePlaceholder}
              />
            </div>
            <div className="col-12 ">
              <input
                style={{ width: '100%' }}
                type="file"
                className="file-elip btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload('back_page')}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateMarriageModal.propTypes = {
  createUpperCaseInput: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  // syncToEs: PropTypes.instanceOf(Function).isRequired,
  getMarriageCertificateList: PropTypes.instanceOf(Function).isRequired,
  createMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_MARRIAGE_CERTIFICATE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateMarriageModal);
